export const addUrlParam = (url: string, param: string, value: string): string =>
    `${url}${url.includes('?') ? '&' : '?'}${param}=${value}`;
